import * as React from 'react';
import { RouteObject } from 'react-router-dom';

const AdminSettings = React.lazy(
    () => import(/* webpackChunkName: "admin-settings" */ '../../../../containers/Admin/Settings')
);
const SelfSettings = React.lazy(
    () => import(/* webpackChunkName: "settings-self" */ '../../../../containers/Shared/Self')
);

export const AdminSettingsRoutes: RouteObject = {
    path: 'settings',
    element: (
        <React.Suspense fallback={<>...</>}>
            <AdminSettings />
        </React.Suspense>
    ),
    children: [
        {
            index: true,
            element: (
                <React.Suspense fallback={<>...</>}>
                    <SelfSettings />
                </React.Suspense>
            )
        }
    ]
};
